import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from 'react-router';
import { ensureKnown, answerQuery } from '../../store/knownDataSlice';
import QueryDetails from '../parts/QueryDetails';
import QueryResponseRejectedReason from '../parts/QueryResponseRejectedReason';
import EditQuery from '../parts/EditQuery';
import UpdatePrice from '../parts/UpdatePrice';
import AnswerQuery from '../parts/AnswerQuery';
import FoodPackages from '../parts/FoodPackages';
import PrivateNotes from '../parts/PrivateNotes';
import SaveOfferPdf from '../parts/SaveOfferPdf';



function AnsweredQueryView(props) {
    const id = useParams()["id"].toUpperCase();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(ensureKnown({ id }));
    }, []);

    const data = useSelector((state) => state.knownData[id]);

    if(!data) return;

    return (
        <div className="column g32 p32 screen center-cross">

            <div className="column g32" style={{ maxWidth: '100%' }}>

                <div className="column g8">
                    <div className="row g16 center-cross">
                        <h1>Päring</h1>
                        <p>{data["query_response_status"] == 'waiting' ? "(ootab vastust)" : "(vastatud)"}</p>
                        {data["query_response_price"] != null && <SaveOfferPdf id={id} />}
                    </div>
                    <h2>{JSON.parse(data["query_route"]).map(route => route["city_name"]).join(" - ")}</h2>
                </div>

                <QueryDetails id={id} />

                <FoodPackages id={id} />

                { data["query_response_status"] == 'rejected' && (
                    <>
                        <hr />
                        <QueryResponseRejectedReason id={id} />
                    </>
                )}

                <PrivateNotes id={id} />

                <AnswerQuery id={id} secondTime={true} />

                <EditQuery id={id} />

            </div>

        </div>
    );
};

export default AnsweredQueryView;